import React from 'react';
import PulseCTA from './PulseCTA';

export default function ClosingCTA() {
  return (
    <section className="bg-[#FBFAF6] border-t border-[#E8E4D9]">
      <div className="dwx py-24">
        <div className="max-w-3xl">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/60 mb-6">Start here</div>
          <h2 className="serif-tight text-[42px] md:text-[64px] leading-[0.98] text-[#1A1A1A]">
            Start with one thing that works.
          </h2>
          <p className="mt-8 text-[17px] leading-relaxed text-[#1A1A1A]/75">
            A 60-minute working session with two of our engineers. You bring a delivery problem. You leave with a written assessment of where AI would help, where it would not, and what it would take to find out.
          </p>
          <p className="mt-2 text-[13px] text-[#1A1A1A]/50">No pitch deck. No obligation.</p>
          <div className="mt-10">
            <PulseCTA to="/contact" size="lg" variant="green" testId="closing-cta-book-session">
              Book a working session
            </PulseCTA>
          </div>
        </div>
      </div>
    </section>
  );
}
